export default {"src":"/_next/static/media/icon-phone.0061ec32.svg","height":16,"width":17,"blurWidth":0,"blurHeight":0};